import React from 'react';
import { colors } from '../constants';

const TestIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width}
    height={props.height}
    viewBox="0 0 20 20"
  >
    <path
      fill={props.color}
      d="M16.415 3.693V1.75c0-.138-.112-.25-.25-.25H3.875c-.138 0-.25.112-.25.25v16.42c0 .14.112.25.25.25 8.192.006 12.338.006 12.437 0 .15-.007.25-.142.25-.327l.002-7.87-4.464 4.462c-.1.098-.223.168-.36.2l-3.035.712c-.542.127-1.028-.36-.9-.902l.71-3.035c.033-.136.102-.26.2-.36l7.325-7.325c.114-.114.24-.208.375-.282zm1.5-.07c.186.082.36.2.514.352l.996.997c.658.66.658 1.728 0 2.388l-1.363 1.363v9.448c0 .968-.784 1.75-1.75 1.75H3.874c-.966 0-1.75-.783-1.75-1.75V1.75C2.125.784 2.91 0 3.875 0h12.29c.966 0 1.75.784 1.75 1.75v1.873zM6.298 5.478c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h5.067c.414 0 .75.336.75.75s-.336.75-.75.75H6.298zm0 3.513c-.415 0-.75-.335-.75-.75 0-.413.335-.75.75-.75h1.69c.413 0 .75.337.75.75 0 .415-.337.75-.75.75h-1.69zm3.243 4.87l1.65-.387L18.365 6.3c.074-.074.074-.194 0-.268l-.995-.996c-.075-.074-.196-.074-.27 0L9.93 12.21l-.387 1.65z"
    />
  </svg>
);

TestIcon.defaultProps = {
  color: colors.mediumGrey,
};

export default TestIcon;
